import { render } from "./BattlesFilterPrice.vue?vue&type=template&id=fae84702&scoped=true"
import script from "./BattlesFilterPrice.vue?vue&type=script&lang=js"
export * from "./BattlesFilterPrice.vue?vue&type=script&lang=js"

import "./BattlesFilterPrice.vue?vue&type=style&index=0&id=fae84702&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae84702"]])

export default __exports__